//#region IMPORT
import React, { useState } from 'react';
/** Components Import */
import { Box, Stack, Typography } from '@mui/material';
import { Button } from '../../../../Components/MUIs';
import ReactPlayer from 'react-player/lazy';
import { useSelector } from 'react-redux';
//#endregion

function M_EduVideos_BASIC(props) {
  const { participantData, videoPlaying } = useSelector((state) => state.tbm);

  /** 참가자: 브라우저 정책상 무음 자동재생 후 탭으로 소리 허용 */
  const [participantAudioUnlocked, setParticipantAudioUnlocked] =
    useState(false);
  const IsHost = participantData.hostYn === 'Y';
  const ParticipantMuted = !IsHost && !participantAudioUnlocked;

  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          영상 교육
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          {IsHost
            ? '영상을 재생하여 교육을 시작해주세요.'
            : '진행자 화면에 맞춰 재생됩니다. 소리는 영상을 한 번 눌러 켤 수 있습니다.'}
        </Typography>
      </Stack>
      {!props.inputs.video ? (
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          width="100%"
          sx={{ minHeight: '300px' }}
        >
          <Typography variant="h5" fontWeight={550}>
            등록된 동영상이 없습니다.
          </Typography>
          <Typography variant="body1">관리자에게 문의하세요.</Typography>
        </Box>
      ) : (
        <Box sx={{ bgcolor: '#000000', position: 'relative' }}>
          <ReactPlayer
            ref={props.videoRef}
            url={props.inputs.video}
            width="100%"
            playsinline
            muted={ParticipantMuted}
            controls={IsHost}
            onPlay={IsHost ? props.HandlePlay : undefined}
            onPause={IsHost ? props.HandlePause : undefined}
            onReady={props.HandleReady}
            onEnded={props.HandleVideoEnd}
            onProgress={props.HandleProgress}
            onSeek={props.HandleSeek}
            onError={(e) => props.HandleVideoError(e)}
            progressInterval={1000} // 1000ms마다 onProgress 호출
            playing={videoPlaying}
            config={{
              file: {
                attributes: {
                  playsInline: true,
                  'webkit-playsinline': 'true',
                  preload: 'metadata',
                },
              },
            }}
            style={{ minHeight: '300px' }}
          />
          {!IsHost && !participantAudioUnlocked && (
            <Box
              onClick={() => setParticipantAudioUnlocked(true)}
              sx={{
                position: 'absolute',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'rgba(0,0,0,0.45)',
                zIndex: 1,
                cursor: 'pointer',
              }}
            >
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '15px',
                  px: 2,
                  textAlign: 'center',
                }}
              >
                소리를 들으려면 여기를 눌러주세요
              </Typography>
            </Box>
          )}
        </Box>
      )}
      {participantData.hostYn === 'Y' && (
        <Stack
          sx={{
            p: 2,
            mt: 2,
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
          }}
          direction={'row'}
          spacing={3}
        >
          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name={props.inputs.isNext ? '완료' : '다음 단계'}
            disabled={props.isTransitioning}
            onClick={props.onAdvanceToNextStep}
          />
        </Stack>
      )}
    </>
  );
}

export default M_EduVideos_BASIC;
